

























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BContainer, BRow, BCol, BButtonGroup, BButton } from 'bootstrap-vue';
import { BookingSlot } from '@bookings/interfaces/online-bookings';

@Component({
  name: 'bpc-slot-selector',
  components: {
    BContainer,
    BRow,
    BCol,
    BButtonGroup,
    BButton,
  },
})
export default class SlotSelector extends Vue {
  @Prop(Object) readonly value: BookingSlot;
  @Prop(Array) readonly slots: BookingSlot[];
  @Prop(Boolean) readonly slotsLoaded: boolean;

  showInfoModal = false;
  infoSlot: BookingSlot = null;
  get model() {
    return this.value;
  }

  set model(value: BookingSlot) {
    this.$emit('input', value);
  }

  // TODO for the moment we will not display slots that are not available
  // but everything is prepare to do it, if we decide to revert to the previous behavior
  // just use the slots with no filter
  get availableSlots() {
    return this.slots.filter(slot => slot.canBeBooked);
  }

  selectSlot(slot: BookingSlot) {
    this.model = null;
    if (slot.canBeBooked) {
      this.model = slot;
    } else {
      this.showInformationModal(slot);
    }
  }

  showInformationModal(slot: BookingSlot) {
    this.infoSlot = slot;
    this.showInfoModal = true;
  }
  closeInfoModal() {
    this.infoSlot = null;
    this.showInfoModal = false;
  }
}
